module.exports = __webpack_public_path__ + "img/2.ea0c629c.png";